import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { Stacker } from "@/components/molecules/Stacker";
import { AboutAccessMap } from "@/components/organisms/AboutAccessMap";
import { AboutGreeting } from "@/components/organisms/AboutGreeting";
import { AboutHistory } from "@/components/organisms/AboutHistory";
import { AboutMission } from "@/components/organisms/AboutMission";
import { AboutNav } from "@/components/organisms/AboutNav";
import { AboutPhilosophy } from "@/components/organisms/AboutPhilosophy";
import { AboutProfile } from "@/components/organisms/AboutProfile";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";

export const getStaticProps = async () => {
  const headers = {
    "X-MICROCMS-API-KEY": process.env.X_MICROCMS_API_KEY,
  };

  // 会社概要の取得
  const companyApiUrl = "https://ab1ue7gpa0.microcms.io/api/v1/company";

  const companyResponse = await fetch(companyApiUrl, { headers: headers });
  const companyJson = await companyResponse.json();

  return {
    props: {
      company: companyJson ? companyJson : {},
    },
  };
};

export default function AboutPage(props = {}) {
  const isHeaderRelative = true;
  const company = props.company || {};
  const { parse } = useBudouX();
  return (
    <>
      <Meta
        pageTitle={"会社概要"}
        pageDescription={
          "株式会社トッカシステムズの会社概要です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/about/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            {/* <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Product",
                },
              ]}
            /> */}
            <Inner className="max-w-full">
              {/* <AboutCover /> */}
              <AboutNav />
              <Stacker>
                <AboutMission />
                <AboutGreeting />
                <AboutPhilosophy />
                <AboutHistory />
                <AboutProfile company={company} />
                <AboutAccessMap />
              </Stacker>
            </Inner>
          </Container>
        </main>
        <Contact>
          システム構築のご相談やご依頼など、お悩みのことがあれば、お気軽にお問い合わせください。
        </Contact>
        <Careers />
        <Footer />
      </Layout>
    </>
  );
}
